'use es6';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UIList from 'UIComponents/list/UIList';

var ExpandableThemeAssets = function ExpandableThemeAssets(_ref) {
  var assetNamesBySubType = _ref.assetNamesBySubType;
  var renderedSections = useMemo(function () {
    return assetNamesBySubType.map(function (value, key) {
      return React.createElement(UIAccordionItem, {
        key: key,
        defaultOpen: true,
        flush: true,
        title: React.createElement("b", null, React.createElement(FormattedMessage, {
          message: "marketplacelib.packCounts.subTypes." + key,
          options: {
            count: value.size
          }
        }))
      }, React.createElement(UIList, {
        className: "p-left-4",
        styled: true
      }, value.map(function (assetName) {
        return assetName;
      }).toArray()));
    }).toArray();
  }, [assetNamesBySubType]);
  return renderedSections;
};

ExpandableThemeAssets.propTypes = {
  assetNamesBySubType: PropTypes.instanceOf(Immutable.Map)
};
ExpandableThemeAssets.defaultProps = {
  assetNamesBySubType: Immutable.Map()
};
export default ExpandableThemeAssets;